import { get, isEqual } from 'lodash';

const errorsFromMutation = (start, data) => get(data, `${start}.errors`, null);

export const getGqlErrors = (data) => {
  const [mutationType] = Object.keys(data);
  const gqlErrors = errorsFromMutation(mutationType, data);

  return gqlErrors;
};

export const shouldUpdateListOrder = (newList, previousList) => {
  if (newList.length < previousList.length || !newList.length) {
    return false;
  }
  if (newList.length > previousList.length) {
    return true;
  }
  return !newList.every((task, idx) => {
    return task.id === previousList[idx]?.id;
  });
};

export const shouldUpdateValue = (cachedValue, localValue) =>
  !isEqual(cachedValue, localValue);
